import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { StyledContent } from '@/components/styles'
import { WikiArticle } from '@/components'

const WikiArticles = ({ data }) => {
  return (
    <StyledContent.WikiArticles>
      <TransitionGroup component={null}>
        {data.map(article => {
          const { id } = article
          return (
            <CSSTransition
              in={true}
              key={id}
              timeout={{
                appear: 0,
                enter: 400,
                exit: 0,
              }}
              classNames="on"
            >
              <WikiArticle key={id} {...article} />
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </StyledContent.WikiArticles>
  )
}

export default WikiArticles
